import Button from "components/atoms/Button/Button";
import React from "react";
import { Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { FormattedMessage, useIntl } from "react-intl";

const PageNotFound = function () {
  const intl = useIntl();
  const navigate = useNavigate();
  return (
    <Row>
      <Col md={12}>
        <h1 className="mb-4">
          <FormattedMessage id="pageNotFound.pageNotFound" defaultMessage="Page not found" />
        </h1>

        <p>
          <FormattedMessage
            id="pageNotFound.sorryPageLookingNotFound"
            defaultMessage="Sorry, the page you were looking for could not be found."
          />
        </p>
        <Button
          label={intl.formatMessage({
            id: "general.back",
            defaultMessage: "Back",
          })}
          className="mt-4"
          onClick={() => {
            navigate(-2);
          }}
        />
      </Col>
    </Row>
  );
};

export default PageNotFound;
